var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.notificationMessage)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.notificationMessage)+" ")]):_vm._e(),_c('Items',{attrs:{"search-term":_vm.searchTerm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }